module.exports = __webpack_public_path__ + "ath_game_web/img/9.6.9825fc2e.png";